import React from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useBookingEditText } from "../text";
import { createTypographyHelper } from "../../../../utils/typography";

const DateIcon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/form-icons/date.svg";

const dateTimeContainer = ({ className, children }) => {
  return (
    <div className="custom-datepicker-container">
      <div className={className}>{children}</div>
    </div>
  );
};

const TravelDatePicker = ({ value, onSelect }) => {
  const { t, language } = useBookingEditText();
  const getTypographyClass = createTypographyHelper(language);
  const lang = language.toUpperCase();

  const dateFormat = {
    "en": "YYYY/MM/DD (ddd)",
    "jp": "YYYY/MM/DD (ddd)",
  };
  return (
    <div className="tw:flex tw:flex-col">
      <div className={`tw:mb-2 tw:text-[#8d8d8d] ${getTypographyClass(13)}`}>
        {t("editBooking.BookingEditPage.basicInformation.travelDate")}
      </div>
      <DatePicker
        locale={lang === "EN" || lang === "en" ? "en" : "ja"}
        selected={value}
        minDate={new Date()}
        calendarContainer={dateTimeContainer}
        onSelect={onSelect}
        customInput={
          <div className="tw:relative">
            <input
              readOnly={true}
              autoComplete="off"
              type="text"
              name="traveldate"
              className={`tw:h-[50px] tw:w-full tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-white tw:pl-[50px] tw:pr-[14px] tw:outline-none focus:tw:border-[#282828] ${getTypographyClass(14)} tw:font-hanken-grotesk tw:!text-[#282828]`}
              placeholder="Travel date"
              aria-label="Travel date"
              value={value ? moment(value).format(dateFormat[lang.toLowerCase()]) : ""}
            />
            <span className="tw:absolute tw:left-[14px] tw:top-1/2 tw:-translate-y-1/2">
              <img alt="date" src={DateIcon} className="tw:w-[18px] tw:h-[18px]" />
            </span>
          </div>
        }
      />
    </div>
  );
};

export default TravelDatePicker;
